import { React, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import axios from "axios";
import { IoMdCheckmark } from "react-icons/io";
import Logo from "../Logo.png";

const HomeScreen = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile_number: "",
    consumer_number: "",
    email: "",
    city: "",
    monthly_bill: "",
    system_capacity: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMsg, setResponseMsg] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMsg("");
  
    // Convert formData into URL-encoded string for PHP (using URLSearchParams)
    const data = new URLSearchParams();
    for (const key in formData) {
      data.append(key, formData[key]);
    }
  
    try {
      const response = await axios.post(
        "https://3esolarventures.com/backend/submit_quotation.php", // Updated endpoint
        data,
        {
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }
      );
      console.log(response);
      setResponseMsg("Quotation requested successfully!");
      // Optionally, clear the form
      // setFormData({
      //   name: "",
      //   mobile_number: "",
      //   consumer_number: "",
      //   email: "",
      //   city: "",
      //   monthly_bill: "",
      // });
    } catch (error) {
      console.error("Error requesting quotation:", error);
      setResponseMsg("There was an error requesting the quotation. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
      <Navbar />

      <section className="bg-white py-12 md:py-16 pl-5 md:pl-20 pt-20">
  <div className="mx-auto flex flex-col-reverse md:flex-row items-center justify-between relative">
    {/* Text content */}
    <div className="w-full md:w-1/2 space-y-4 md:space-y-6 text-center md:text-left mt-10">
      <h1 className="text-3xl md:text-5xl font-medium text-gray-800 leading-tight mb-2">
        Switch to Solar & Save <br />
        <span className="text-[#039147] font-bold text-4xl md:text-6xl">
          ₹1 Lakh+ Annually
        </span>{" "}
        on <br />
        Electricity Bills!
      </h1>
      <p className="text-gray-600 md:text-lg">
        Join the green revolution and reduce your carbon footprint while
        enjoying significant savings.
      </p>
      <div className="space-y-3 pt-4">
        <div className="flex items-center space-x-2 border border-gray-300 rounded-full w-fit px-7 py-2">
          <img src="images/zero costicon.png" alt="Zero Upfront Cost" className="w-6 h-6" />
          <span className="text-gray-700">Zero Upfront Cost</span>
        </div>
        <div className="flex items-center space-x-2 border border-gray-300 rounded-full w-fit px-7 py-2">
          <img src="images/subsidyicon.png" alt="30% Subsidy" className="w-6 h-6" />
          <span className="text-gray-700">30% Subsidy (Govt. of India)</span>
        </div>
        <div className="flex items-center space-x-2 border border-gray-300 rounded-full w-fit px-7 py-2">
          <img src="images/warrantyicon.png" alt="25-year warranty" className="w-6 h-6" />
          <span className="text-gray-700">25-Year Warranty</span>
        </div>
      </div>
    </div>

    {/* Image on top for mobile, right for desktop */}
    <div className="w-full flex justify-center md:justify-end">
      <img
        src="images/Hero_Image.png"
        alt="Solar Panel Hero"
        className="w-full object-cover max-h-60 md:max-h-full md:w-auto"
      />
    </div>
  </div>
</section>



      <section className="bg-gradient-to-r from-blue-50 to-white px-4 md:px-16 py-12">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl font-semibold text-gray-800">
            Avail up to <span className="text-[#039147]">40% Subsidy</span> for
            Residential Solar
          </h2>
          <p className="text-gray-600 mt-3 md:text-lg">
            Under PM Surya Ghar Yojana, install solar and save big on
            electricity.
          </p>
          <img
            src="images/PmYojna.png"
            alt="PM Yojna"
            className="w-full mt-10"
          />
          <div className="mt-6">
            <button className="text-[#039147] px-6 py-3 mt-5 rounded-full font-medium transition">
              Learn More
            </button>
          </div>
        </div>
      </section>

      <div
        className="min-h-screen bg-gradient-to-l from-[#3DB577] to-[#039147] py-12 px-4"
        id="quotation"
      >
        <div className="max-w-6xl mx-auto h-full">
          <div className="flex flex-col items-center mb-10">
            <button className="bg-white text-[#039147] px-6 py-3 rounded-full font-medium shadow-md transition">
              Get a Free Quote in 1 Minute ⚡️
            </button>
            <h1 className="text-3xl md:text-4xl font-semibold text-white text-center mt-6 leading-tight">
              Discover how much you can save with Solar!
            </h1>
            <p className="text-white text-center mt-2 md:text-lg">
              30% Govt. Subsidy Included | EMI Options Starting at ₹4,999/month
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-stretch min-h-[600px] mb-20">
            {/* Image Container */}
            <div className="md:w-1/2  relative rounded-l-xl overflow-hidden shadow-lg">
              <img
                src="images/Quote_image.png"
                alt="Solar Panels"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Form Container */}
            <div className="md:w-1/2 bg-white p-6 md:p-8 rounded-r-xl shadow-xl flex flex-col ">
              <img src={Logo} className="h-30 object-cover w-1/2" />
              <form
                className="flex-1 space-y-4 overflow-y-auto"
                onSubmit={handleSubmit}
              >
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your name"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Mobile Number
                  </label>
                  <input
                    type="tel"
                    name="mobile_number"
                    value={formData.mobile_number}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your mobile number"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    MSEB/Consumer Number
                  </label>
                  <input
                    type="text"
                    name="consumer_number"
                    value={formData.consumer_number}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your consumer number"
                    required
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Email Address  <span className="text-red">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter your city"
                    required
                  />
                </div>
                <div>
  <label className="block text-gray-700 font-medium mb-1">
    System Capacity
  </label>
  <input
    type="text"
    name="system_capacity"
    value={formData.system_capacity}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
    placeholder="Desired System Capacity (for ex.10 kW)"
    required
  />
</div>


                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Average Monthly Electricity Bill (₹)
                  </label>
                  <input
                    type="number"
                    name="monthly_bill"
                    value={formData.monthly_bill}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-3xl px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="e.g. 5000"
                    required
                  />
                </div>

                <div className="pt-4 pb-2">
                  <button
                    type="submit"
                    // disabled={loading}
                    className="w-full bg-[#3DB577] text-white font-semibold rounded-3xl px-6 py-3 hover:bg-[#039177] focus:outline-none focus:ring-4 focus:ring-blue-300 transition"
                  >
                    {/* {loading ? "Submitting..." : "Request Quotation"} */}
                    Request Quotation
                  </button>
                </div>

                {responseMsg && (
                  <p className="mt-2 text-center text-gray-700">
                    {responseMsg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>

      <section className="py-12 px-6 md:px-16 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-800 mb-8">
            What Our Clients Say About Us
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center mb-4">
                <img
                  src="images/user_2.jpg"
                  alt="Client 1"
                  className="w-12 h-12 rounded-full mr-3 object-contain"
                />
                <div>
                  <h4 className="text-gray-800 font-semibold">Neeraj Prakash</h4>
                  <p className="text-sm text-gray-500">Nagpur, India</p>
                </div>
              </div>
              <p className="text-gray-600">
                “The installation was seamless, and my electricity bill has
                reduced significantly. Highly recommend!”
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <div className="flex items-center mb-4">
                <img
                  src="images/user_1.jpg"
                  alt="Client 2"
                  className="w-12 h-12 rounded-full mr-3 object-cover"
                />
                <div>
                  <h4 className="text-gray-800 font-semibold">Priyam Sharma</h4>
                  <p className="text-sm text-gray-500">Delhi, India</p>
                </div>
              </div>
              <p className="text-gray-600">
                “I was surprised by how much I could save every month. The team
                was very professional and supportive.”
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomeScreen;
